<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row no-gutters>
          <v-col md="2">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="filter.search"
                  placeholder="Поиск по номеру карты или ФИО"
                  dense
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="end">
              <v-col
                md="2"
                class="text-right"
              >
                <span>Фильтровать по:</span>
              </v-col>
              <v-col md="2">
                <Select
                  v-model="filter.role"
                  label="Тип карты"
                  :items="roles"
                  item-value="id"
                  item-text="name"
                  @change="getDataFromFirstPage"
                  dense
                  blank
                />
              </v-col>
              <v-col md="2">
                <Select
                  v-model="filter.school_class"
                  label="Класс/должность"
                  :items="school_classes"
                  item-value="id"
                  item-text="name"
                  @change="getDataFromFirstPage"
                  dense
                  blank
                />
              </v-col>
              <v-col md="2">
                <DatePicker
                  v-model="filter.blocked_at"
                  labelText="Дата блокировки с"
                  @changeDate="getDataFromFirstPage"
                  dense
                />
              </v-col>
              <v-col md="2">
                <Select
                  v-model="filter.blocked_by"
                  label="Кем блокирована"
                  :items="blockedByList"
                  item-value="id"
                  item-text="name"
                  @change="getDataFromFirstPage"
                  dense
                  blank
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Table
              v-model="selectedCards"
              :headers="headers"
              :items="cards"
              :loading="loading"
              :items-per-page="cardsPerPage"
              :server-items-length="totalCards"
              :sort-by="sort.field"
              :sort-desc="sort.desc"
              :page="page"
              show-select
              class="elevation-1"
              @update:request="updateRequest"
              @update:sort-by="updateSortField"
              @update:sort-desc="updateSortDesc"
            >
              <template v-slot:item.blocked_at="{ item }">
                {{ item.blocked_at | dateTime }}
              </template>
              <template v-slot:item.roles="{ item }">
                {{ item.roles.map(r => r.name).join(', ') }}
              </template>
              <template v-slot:item.blockedRoles="{ item }">
                {{ item.blockedRoles.map(r => r.name).join(', ') }}
              </template>
            </Table>
          </v-col>
        </v-row>
        <v-row v-if="this.selectedCards.length">
          <v-col>
            <v-btn @click="modals.action = modals.activate = true; modals.delete = false">Разблокировать</v-btn>
            <v-btn @click="modals.action = modals.delete = true; modals.activate = false">Удалить</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ConfirmModal
      title="Внимание"
      :dialog.sync="modals.action"
      :confirmBtnText="modals.delete ? 'Удалить' : 'Разблокировать'"
      contentClass="esh-theme adminModal"
      @confirm="applyCardAction"
    >
      <template #body>
        <v-col>
          <v-row v-if="modals.delete">
            Вы действительно хотите удалить выбранные карты?
          </v-row>
          <v-row v-if="modals.activate">
            Вы действительно хотите активировать выбранные карты?
          </v-row>
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { FORMAT, BASE } from '@/config'
import { DatePicker, Table, ConfirmModal, Select } from '@/components/common'
import {
  GET_CARDS_BLOCKED,
  GET_ADMIN_CLASSES,
  DELETE_CARDS,
  ACTIVATE_CARDS
} from '@/requests/admin'

const GUEST_ROLE = -1
const GUEST_ROLE_DATA = { 'name': 'Гостевая', id: GUEST_ROLE }

export default {
  name: 'CardsBlocked',
  components: {
    DatePicker,
    Table,
    Select,
    ConfirmModal
  },
  data() {
    return {
      blockedByList: [
        { name: 'Администратор', id: 4 },
        { name: 'Родитель', id: 3 }
      ],
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: 'ID', value: 'number', sortable: false },
        { text: 'Тип карты', value: 'roles', sortable: false },
        { text: 'ФИО', value: 'full_name', sortable: false },
        { text: 'Класс/должность', value: 'className', sortable: false },
        { text: 'Дата блокировки', value: 'blocked_at' },
        { text: 'Тип блокировки', value: 'block_reason.name', sortable: false },
        { text: 'Причина', value: 'reason_text', sortable: false },
        { text: 'Кем блокирована', value: 'blockedBy', sortable: false },
        { text: 'Роли автора блокировки', value: 'blockedRoles', sortable: false }
      ],
      cardsPerPage: BASE.LIMIT,
      totalCards: 0,
      page: 1,
      loading: false,
      cards: [],
      school_classes: [],
      selectedCards: [],
      actionErrors: [],
      filter: {
        search: '',
        role: null,
        school_class: null,
        blocked_at: null,
        blocked_by: null
      },
      sort: {
        field: undefined,
        desc: undefined
      },
      modals: {
        delete: false,
        activate: false,
        action: false,
        error: false
      },
      actionData: {
        unlocked: [],
        failed: []
      }
    }
  },
  computed: {
    ...mapState({
      cardRoles: state => state.common.constants.card_roles,
      roleChoices: state => state.common.constants.role_choices,
      blockReasons: state => state.common.constants.card_block_reasons
    }),
    roles() {
      return [...this.cardRoles, GUEST_ROLE_DATA]
    }
  },
  mounted() {
    this.getData()
    this.loadClasses()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchCards()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchCards()
      }
    }
  },
  methods: {
    updateRequest({ page, itemsPerPage, offset }) {
      this.cardsPerPage = itemsPerPage
      this.page = page
      this.getData({
        limit: itemsPerPage,
        offset: offset
      })
    },
    searchCards: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    updateSortDesc(desc) {
      this.sort.desc = Array.isArray(desc) ? desc[0] : desc
      this.getDataFromFirstPage()
    },
    updateSortField(field) {
      this.sort.field = Array.isArray(field) ? field[0] : field
    },
    async getData(params = {}) {
      this.loading = true
      try {
        const { data: { results, count } } = await GET_CARDS_BLOCKED({
          limit: this.cardsPerPage,
          search: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          school_class: this.filter.school_class,
          role: this.filter.role !== GUEST_ROLE ? this.filter.role : null,
          is_guest: this.filter.role === GUEST_ROLE || null,
          blocked_at_from: !this.filter.blocked_at ? null : moment(this.filter.blocked_at).format(FORMAT.datepickerDate),
          blocked_by_role: !this.filter.blocked_by ? null : this.filter.blocked_by,
          ...params
        })

        this.totalCards = count
        this.cards = results
          .map(c => ({
            ...c,
            block_reason: this.blockReasons.find(r => c.block_reason === r.id),
            roles: !c.user ? [GUEST_ROLE_DATA] : c.user.roles.map(r => this.roleChoices.find(role => role.id === r)),
            blockedRoles: c.block_author ? c.block_author.roles.map(r => this.roleChoices.find(role => role.id === r)): [],
            blockedBy: c.block_author ? c.block_author.full_name : 'Не указан',
            className: !c.user ? null : c.user.school_class && c.user.school_class.name,
          }))
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о картах'
        })
      } finally {
        this.loading = false
        this.selectedCards = []
      }
    },
    async loadClasses() {
      try {
        let response = await GET_ADMIN_CLASSES()
        this.school_classes = response.data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    },
    async applyCardAction() {
      this.modals.action = false
      try {
        const ids = this.selectedCards.map(card => card.id)

        if (this.modals.delete) {
          await DELETE_CARDS({ ids })
        } else {
          const { data } = await ACTIVATE_CARDS({ ids })
          if (data.failed.length) {
            data.failed.forEach(item => (
              this.$notify({
                type: 'error',
                text: item.error
              })
            ))
          }
        }

        this.$notify({
          type: 'success',
          text: this.modals.delete ? 'Карты успешно удалены!' : 'Карты успешно активированы!'
        })
      } catch {
        this.$notify({
            type: 'error',
            text: this.modals.delete
                ? 'Неуспешное удаление карт!'
                : 'Неуспешная активация карт!'
        })
      } finally {
        this.getData()
        this.modals.delete = this.modals.activate = false
      }
    }
  }
}
</script>
